
<template>
    <div id="loadingOverlay" :class="{ 'visible' : show }">
        <b-progress :value="100" :max="100" animated style="width: 200px;"></b-progress>
    </div>
</template>

<script>

// import axios from 'axios'

export default {

    props: {
        show : {}
    },
    
    mounted(){

    },

    data : function (){
        return {
            
        }
    },

    methods: {
        
        
    }
};
</script>

<style>

.visible {
    display: flex !important;
}

#loadingOverlay {

    display : none;
    
    align-items: center;
    justify-content: center;
    position: fixed;
    background: rgba(255,255,255, 0.4);
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99999; 
}



</style>
